var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.4488,
    cy: 22.0494,
    r: 21.3414,
    fill: "#C71C8E",
    fillOpacity: 0.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9976 21.6135C30.0998 20.5652 29.6919 19.6567 29.6919 18.1132V17.5884C29.6919 15.5771 29.2289 14.2812 28.2225 12.9853C26.6713 10.9727 24.0599 9.75977 21.5035 9.75977H21.3948C18.8921 9.75977 16.3625 10.917 14.7844 12.8479C13.723 14.1698 13.2064 15.5214 13.2064 17.5884V18.1132C13.2064 19.6567 12.8253 20.5652 11.9007 21.6135C11.2203 22.3859 11.0029 23.3785 11.0029 24.4529C11.0029 25.5285 11.3559 26.5471 12.0643 27.3752C12.989 28.3678 14.2947 29.0015 15.6284 29.1117C17.5595 29.332 19.4906 29.4149 21.4497 29.4149C23.4077 29.4149 25.3387 29.2763 27.271 29.1117C28.6036 29.0015 29.9093 28.3678 30.8339 27.3752C31.5411 26.5471 31.8953 25.5285 31.8953 24.4529C31.8953 23.3785 31.6779 22.3859 30.9976 21.6135Z",
    fill: "#CE1111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.9181 30.9329C23.3037 30.8017 19.5601 30.8017 18.9457 30.9329C18.4205 31.0542 17.8525 31.3364 17.8525 31.9552C17.8831 32.5456 18.2287 33.0667 18.7075 33.3972L18.7063 33.3984C19.3256 33.8811 20.0523 34.1881 20.8133 34.2983C21.2188 34.354 21.6316 34.3515 22.0518 34.2983C22.8115 34.1881 23.5382 33.8811 24.1575 33.3984L24.1563 33.3972C24.6351 33.0667 24.9807 32.5456 25.0113 31.9552C25.0113 31.3364 24.4433 31.0542 23.9181 30.9329Z",
    fill: "#CE1111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification_bell.fa351ccc6b971f308890ec90f7672be8.svg";
export { ForwardRef as ReactComponent };